import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../../types";
import { FormReportPost } from "./FormReportPost";
import type { HistoryDetailViewReportedPostProps } from "./HistoryDetailViewReportedPost";
import { HistoryDetailViewReportedPost } from "./HistoryDetailViewReportedPost";
import { useAreAiWorkflowActionsEnabled } from "./useAreAiWorkflowActionsEnabled";

export const reportPost: Readonly<
  ActionOption<HistoryDetailViewReportedPostProps>
> = {
  label: t("settings.workflows.form.actions.ai_agents_report_post"),
  textLabel: t("settings.workflows.form.actions.ai_agents_report_post"),
  value: "ai_agents_report_post",
  group: t("settings.workflows.form.action_groups.ai_agents"),
  leftAddon: <Icon type="16-ai-report" size={16} className="!h-4 !w-4" />,
  formComponent: FormReportPost,
  viewComponent: null,
  historyDetailViewComponent: HistoryDetailViewReportedPost,
  icon: "chat",
  isApplicableToMembersOnly: false,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
  released: useAreAiWorkflowActionsEnabled,
} as const;
